import D2bTable from './D2bTable.container';

export default D2bTable;
